/* eslint-disable */

export enum HistoricalRange {
  DAY = "DAY",
  WEEK = "WEEK",
  MONTH = "MONTH",
  YEAR = "YEAR",
  ALL = "ALL",
}

/**
 * An encoded version of this proto is used as the identifier for tax information to be presented
 * in the investing flow.
 */
export interface TaxToken {
  /** Token of the flow where the tax information is to be displayed. */
  flow_token?: string;
  /** Cash service where the flow token originated. */
  flow_type?: TaxTokenFlowType;
  /**
   * Timestamp when this token was issued.
   * Up to the application validating these to decide how long they last.
   */
  issued_at?: number;
  /** Customer who's tax information will be displayed. */
  customer_token?: string;
}

export enum TaxTokenFlowType {
  FRANKLIN = "FRANKLIN",
  PLASMA = "PLASMA",
}
